import {type BskyAgent} from '@atproto/api'

import {wsocFetch, xrpcPath} from '#/lib/wsoc/fetch'
import {type GetVerificationStatusResponse} from './types'

/**
 * Fetch the current WID verification status for the authenticated account.
 * Polled by the verification wizard to detect QR scan and completion.
 *
 * @throws Error when the agent has no accessJwt.
 */
export async function getVerificationStatus(
  agent: BskyAgent,
  options?: {signal?: AbortSignal},
): Promise<GetVerificationStatusResponse> {
  const accessJwt = agent.session?.accessJwt
  if (!accessJwt) {
    throw new Error('getVerificationStatus requires an authenticated session')
  }
  return wsocFetch<GetVerificationStatusResponse>(
    xrpcPath('eu.wsocial.getVerificationStatus'),
    {method: 'GET', accessJwt, signal: options?.signal},
  )
}
